import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminLogin = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState(``);
  const [password, setPassword] = useState(``);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const CustomInputProps = {
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          edge="end"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  };

  const handleLogin = () => {
    axios
      .post(`/api/v1/users/login`, {
        account: username,
        password: password,
      })
      .then((res) => {
        localStorage.removeItem("accessToken")
        localStorage.setItem("userId", res.data.userId)
        localStorage.setItem("permissions", res.data.permissions)
        toast("Đăng nhập thành công!", {
          type: "success",
          autoClose: 1000,
        });
        navigate(`/admin`)
      })
      .catch((err) => {
        toast(err.response.data.message, {
          type: "error",
          autoClose: 2000,
        });
      })
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <Box
      component="section"
      sx={{
        p: 3,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper sx={{ height: 500, width: 400, p: 3 }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ textAlign: "center", paddingBottom: 5 }}
        >
          ĐĂNG NHẬP
        </Typography>
        <TextField
          label="Tài khoản"
          variant="outlined"
          sx={{ width: "100%", paddingBottom: 5 }}
          onChange={(e) => setUsername(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <TextField
          label="Mật khẩu"
          type={showPassword ? "text" : "password"}
          variant="outlined"
          sx={{ width: "100%", paddingBottom: 5 }}
          slotProps={{
            input: CustomInputProps,
          }}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button variant="contained" color="info" sx={{ width: 150 }} onClick={handleLogin}>
            Đăng nhập
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AdminLogin;
